import { render } from "./EditBranch.vue?vue&type=template&id=1402ebd6"
import script from "./EditBranch.vue?vue&type=script&lang=js"
export * from "./EditBranch.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/branches/EditBranch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1402ebd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1402ebd6', __exports__)) {
    console.log('reload')
    api.reload('1402ebd6', __exports__)
  }
  
  module.hot.accept("./EditBranch.vue?vue&type=template&id=1402ebd6", () => {
    console.log('re-render')
    api.rerender('1402ebd6', render)
  })

}


export default __exports__